module.exports = __webpack_public_path__ + "img/cloud.c30f063c.svg";